
			// import Swup from 'swup';
			// const swup = new Swup({
			// 	containers: ["#swup"]
			// });
			// swup.hooks.on('visit:start', () => {
			// 	console.debug("swup hooks");
			// 	console.debug(window.location.href);
			// })

			function getCookie(name) {
				return (
					document.cookie
						.split("; ")
						.find((row) => row.startsWith(name + "="))
						?.split("=")[1] ?? // value (still URL-encoded)
					null
				);
			}

			function mainApp(_lang, _entity, _sub, _cookie_name, _create_uid, _show_locale) {
				return {
					current_nav: _entity,
					show_locale: _show_locale, //this.$persist(true).as("show_locale"),
					pref_lang: this.$persist("").as("pref_lang"),

					locale: "",

					lang: _lang,
					entity: _entity,
					sub: _sub,

					topnav_title: "",

					show_topfloat: false,
					name_topfloat: "",

					show_bottomfloat: false,
					name_bottomfloat: "",

					is_login: this.$persist(0).as("is_login"),

					show_person: false,
					person_id: 0,
					qty: this.$persist(0).as("qty"),
					price: 2900,
					discount_diff: this.$persist(0).as("discount_diff"),
					payment: this.$persist("").as("payment"),

					coupon_code: this.$persist("").as("coupon_code"),
					coupon_rules: [],

					order_uid: 100,
					order_total: "0.00",

					db_order_uid: "ORDER_UID",
					db_order_total: "0.00",

					geo: [],

					slip: false,
					slip_url: "",

					adr_billing: this.$persist({
						provinceNameTh: "",
						districtNameTh: "",
						subdistrictNameTh: "",
						postalCode: "",
					}).as("adr_billing"),
					adr_delivery: this.$persist({
						provinceNameTh: "",
						districtNameTh: "",
						subdistrictNameTh: "",
						postalCode: "",
					}).as("adr_delivery"),

					adrChange(adr, name) {
						console.debug("adrChange:", name, adr);

						if (name === "province") {
							adr.districtNameTh = "";
							adr.subdistrictNameTh = "";
							adr.postalCode = "";
						} else if (name === "district") {
							adr.subdistrictNameTh = "";
							adr.postalCode = "";
						} else if (name === "subdistrict") {
							adr.postalCode = "";
						}
					},

					adrData(adr, name) {
						// adr: {
						// 	provinceNameTh: "",
						// 	districtNameTh: "",
						// 	subdistrictNameTh: "",
						// 	postalCode: "",
						// }

						// let filtered = this.geo.filter(r => {
						// 	if (adr.provinceNameTh !== "" && r.provinceNameTh !== adr.provinceNameTh) return false;
						// 	if (adr.districtNameTh !== "" && r.districtNameTh !== adr.districtNameTh) return false;
						// 	if (adr.subdistrictNameTh !== "" && r.subdistrictNameTh !== adr.subdistrictNameTh) return false;
						// 	if (adr.postalCode !== "" && String(r.postalCode) !== String(adr.postalCode)) return false;
						// 	return true;
						// });

						// console.debug("filtered:", filtered.length);

						if (name === "province") {
							let filtered = this.geo.filter((r) => {
								// if (adr.provinceNameTh !== "" && r.provinceNameTh !== adr.provinceNameTh) return false;
								// if (adr.districtNameTh !== "" && r.districtNameTh !== adr.districtNameTh) return false;
								// if (adr.subdistrictNameTh !== "" && r.subdistrictNameTh !== adr.subdistrictNameTh) return false;
								// if (adr.postalCode !== "" && String(r.postalCode) !== String(adr.postalCode)) return false;
								return true;
							});

							let arr = [...new Set(filtered.map((r) => r.provinceNameTh.trim()))];
							console.debug("provinces:", arr.sort());
							return arr.sort();
						}

						if (name === "district") {
							if (adr.provinceNameTh === "") return [];
							let filtered = this.geo.filter((r) => {
								if (adr.provinceNameTh !== "" && r.provinceNameTh !== adr.provinceNameTh) return false;
								// if (adr.districtNameTh !== "" && r.districtNameTh !== adr.districtNameTh) return false;
								// if (adr.subdistrictNameTh !== "" && r.subdistrictNameTh !== adr.subdistrictNameTh) return false;
								// if (adr.postalCode !== "" && String(r.postalCode) !== String(adr.postalCode)) return false;
								return true;
							});

							let arr = [...new Set(filtered.map((r) => r.districtNameTh.trim()))];
							console.debug("districts:", arr);
							return arr.sort();
						}

						if (name === "subdistrict") {
							if (adr.provinceNameTh === "") return [];
							if (adr.districtNameTh === "") return [];
							let filtered = this.geo.filter((r) => {
								if (adr.provinceNameTh !== "" && r.provinceNameTh !== adr.provinceNameTh) return false;
								if (adr.districtNameTh !== "" && r.districtNameTh !== adr.districtNameTh) return false;
								// if (adr.subdistrictNameTh !== "" && r.subdistrictNameTh !== adr.subdistrictNameTh) return false;
								// if (adr.postalCode !== "" && String(r.postalCode) !== String(adr.postalCode)) return false;
								return true;
							});

							let arr = [...new Set(filtered.map((r) => r.subdistrictNameTh.trim()))];
							console.debug("subdistricts:", arr);
							return arr.sort();
						}

						if (name === "zipcode") {
							if (adr.provinceNameTh === "") return [];
							if (adr.districtNameTh === "") return [];
							if (adr.subdistrictNameTh === "") return [];
							let filtered = this.geo.filter((r) => {
								if (adr.provinceNameTh !== "" && r.provinceNameTh !== adr.provinceNameTh) return false;
								if (adr.districtNameTh !== "" && r.districtNameTh !== adr.districtNameTh) return false;
								if (adr.subdistrictNameTh !== "" && r.subdistrictNameTh !== adr.subdistrictNameTh) return false;
								// if (adr.postalCode !== "" && String(r.postalCode) !== String(adr.postalCode)) return false;
								return true;
							});

							let arr = [...new Set(filtered.map((r) => r.postalCode))];
							console.debug("zipcodes:", arr);
							return arr.sort();
						}
					},

					// ],
					async loadCoupons() {
						try {
							let res = await fetch("/data/coupons"); // 👈 replace with your real URL
							if (!res.ok) throw new Error("Network error");

							let json = await res.json();
							if (json.success && json.data && json.data.coupons) {
								this.coupon_rules = json.data.coupons;
								console.debug("Loaded coupons:", this.coupon_rules);
							}
						} catch (e) {
							console.error("Failed to load coupons:", e);
						}
					},

					admin_user: this.$persist({
						id: 0,
						username: "guest",
						role: "guest",
					}).as("admin_user"),

					get_uid() {
						return Date.now().toString(); // or your md5 logic
					},

					temp_confirm: 0,

					customer: this.$persist({
						customer_uid: getCookie(_cookie_name),

						email: "",
						password: "",
						title: "",
						first_name: "",
						last_name: "",
						mobile: "",
						birthday: "",
						billing_address: "",
						billing_subdistrict: "",
						billing_district: "",
						billing_province: "",
						billing_zipcode: "",

						same_address: true,

						delivery_address: "",
						delivery_subdistrict: "",
						delivery_district: "",
						delivery_province: "",
						delivery_zipcode: "",

						subscribed: "",

						ref: "",
						points: 0,
					}).as("_cust"),

					get total() {
						return this.qty * this.price;
					},

					get grand_total() {
						return this.qty * this.price - this.discount_diff;
					},

					get activeCoupon() {
						// find the rule for this code with the highest min_qty <= qty
						return (
							this.coupon_rules
								.filter((c) => c.coupon_code === this.coupon_code && this.qty >= c.min_qty)
								.sort((a, b) => b.min_qty - a.min_qty)[0] || {
								coupon_id: 0,
								coupon_code: this.coupon_code,
								min_qty: this.qty,
								discount_type: "amount",
								discount_value: 0,
								ref_code: "",
								details: "ไม่พบโค้ดส่วนลด",
							}
						);
					},

					get discount() {
						if (this.customer.ref != "" && this.activeCoupon.ref_allowed == 0) {
							// no discount if ref code is used and ref_allowed is 0
							this.discount_diff = 0;
							return this.discount_diff;
						}

						if (this.activeCoupon.discount_type === "percent") {
							this.discount_diff = Math.round(this.price * this.qty * this.activeCoupon.discount_value * 100) / 100;
							return this.discount_diff;
						} else if (this.activeCoupon.discount_type === "amount") {
							this.discount_diff = this.activeCoupon.discount_value;
							return this.discount_diff;
						}
						this.discount_diff = 0;
						return this.discount_diff;
					},

					async CSPay(_amount, _payment, _order_id) {
						const merchantId = "3D479X2530";
						const shopId = 266;
						const secretKey = "sjBNsD/PCmi+rsEjLeH9dgpg0Q0oe5xCFLf72huFu9g=";
						const amount = _amount;
						const paymentMethod = _payment;
						const resultEl = document.getElementById("result");

						if (!merchantId || !shopId || !secretKey || !amount) {
							alert("กรุณากรอกข้อมูลให้ครบ");
							return;
						}

						resultEl.classList.remove("hidden");
						resultEl.textContent = "⏳ กำลังเรียก API ...";

						const invNo = new Date()
							.toISOString()
							.replace(/[-:.TZ]/g, "")
							.slice(0, 14);

						const order = {
							merchantId,
							shopId,
							inv: invNo,
							desc: `OrderID: ${_order_id} - ${paymentMethod}`,
							// urlBack: `https://aedezel.com/${_lang}/paid/${_order_id}`,
							urlBack: `https://aedezel.com/api/cspay/back/${_order_id}?lang=${_lang}`,
							urlConfirm: `https://aedezel.com/api/cspay/confirm/${_order_id}`,
							paymentMethod,
							amt: Number(amount).toFixed(2),
							currency: "THB",
							redirectResult: "N",
						};

						try {
							const res = await fetch("https://apigw-apisvc.counterservicepay.co/paymentservice/v2/signature/encrypt", {
								method: "POST",
								headers: {
									"Content-Type": "application/json",
									merchantId,
									secretKey,
								},
								body: JSON.stringify(order),
							});

							const data = await res.json();
							console.log("Response:", data);

							if (!data.encryptedPaymentData) {
								resultEl.textContent = "❌ ไม่พบ encryptedPaymentData\n\n" + JSON.stringify(data, null, 2);
								return;
							}

							const scriptUrl = "https://secure.counterservicepay.com/cspay.js";
							await new Promise((resolve, reject) => {
								const script = document.createElement("script");
								script.src = scriptUrl;
								script.onload = () => resolve();
								script.onerror = () => reject(new Error("โหลด cspay.js ไม่สำเร็จ"));
								document.head.appendChild(script);
							});

							resultEl.textContent = "✅ Payment Data พร้อมใช้งาน\n\n" + JSON.stringify(data, null, 2);

							// เรียก CSPay
							CSPay.configure({
								paymentData: data.encryptedPaymentData,
							});
						} catch (err) {
							resultEl.textContent = "❌ Error: " + err.message;
						}
					},

					selected_lang: "th",

					country_code: "",

					async init() {
						if (this.pref_lang != "" && this.show_locale) location.href = "/" + this.pref_lang;

						console.debug("mainApp: current_nav=" + this.current_nav);

						console.log("ses", getCookie(_cookie_name));

						if (this.show_locale) {
							fetch("https://ipwho.is/")
								.then((res) => res.json())
								.then((data) => {
									console.log("IP:", data.ip);
									console.log("Country:", data.country);
									console.log("Country Code:", data.country_code);
									console.log("City:", data.city);
									console.log("Region:", data.region);

									this.locale = data.country_code.toLowerCase();
									this.locale = this.locale != "th" ? "en" : "th";

									this.selected_lang = this.locale;
									this.country_code = data.country_code;
								})
								.catch((err) => console.error("Error fetching IP info:", err));
						}
						this.loadCoupons();

						// const adr_billing = this.$persist({
						// provinceNameTh: "",
						// districtNameTh: "",
						// subdistrictNameTh: "",
						// postalCode: "",
						// }).as("adr_billing");

						this.$watch("adr_billing", (value, oldValue) => {
							this.customer.billing_province = value.provinceNameTh;
							this.customer.billing_district = value.districtNameTh;
							this.customer.billing_subdistrict = value.subdistrictNameTh;
							this.customer.billing_zipcode = value.postalCode;
						});

						this.$watch("adr_delivery", (value, oldValue) => {
							this.customer.delivery_province = value.provinceNameTh;
							this.customer.delivery_district = value.districtNameTh;
							this.customer.delivery_subdistrict = value.subdistrictNameTh;
							this.customer.delivery_zipcode = value.postalCode;
						});

						this.$watch("customer", (value, oldValue) => {
							if (value.same_address) {
								this.customer.delivery_address = this.customer.billing_address;

								this.adr_delivery.provinceNameTh = this.adr_billing.provinceNameTh;
								this.adr_delivery.districtNameTh = this.adr_billing.districtNameTh;
								this.adr_delivery.subdistrictNameTh = this.adr_billing.subdistrictNameTh;
								this.adr_delivery.postalCode = this.adr_billing.postalCode;
							}
						});

						if (this.current_nav == "member") {
							console.debug("sub:member");
						}

						if (this.current_nav == "checkout") {
							console.debug("checkout done");

							this.order_uid = _create_uid;
							this.order_total = this.grand_total;

							const res = await fetch("/api/checkout", {
								method: "POST",
								headers: { "Content-Type": "application/json" },
								body: JSON.stringify({
									customer: this.customer,
									adr_billing: this.adr_billing,
									adr_delivery: this.adr_delivery,
									payment: this.payment,
									coupon: this.activeCoupon.coupon_code,
									qty: this.qty,
									price: this.price,
									discount: this.discount_diff,
									total: this.grand_total,
									order_uid: this.order_uid,
								}),
							});

							const res_json = await res.json();

							// clear cart
							// this.qty=0;
							// this.coupon_code = "";

							console.debug("checkout res:", res_json);
							// location.href = "/th/manual-order?order_uid=" + this.order_uid;

							this.CSPay(this.grand_total, this.payment, this.order_uid);
						}

						if (this.current_nav == "paid") {
							console.debug("paid checking : ", _sub);

							const res = await fetch("/api/paid", {
								method: "POST",
								headers: { "Content-Type": "application/json" },
								body: JSON.stringify({
									order_uid: _sub,
								}),
							});

							alert("Thank for your order");
							this.qty = 0;
							this.coupon_code = "";

							location.href = "/";
						}

						if (this.current_nav == "manual-order") {
							console.debug("manual-order done");

							this.qty = 0;

							const params = new URLSearchParams(window.location.search);

							let order_uid = params.get("order_uid") || "";
							if (order_uid == "") location.href = "";

							const res = await fetch("/api/manual-order?order_uid=" + order_uid, {
								method: "GET",
							});

							const res_json = await res.json();

							console.debug("manual-order res:", res_json);

							this.order_uid = res_json.data.orders[0].order_uid;
							this.order_total = res_json.data.orders[0].total;

							this.db_order_uid = res_json.data.orders[0].order_uid;
							this.db_order_total = res_json.data.orders[0].total;

							this.has_slip = res_json.data.orders[0].has_slip;

							this.slip_url = res_json.data.orders[0].slip_url; //'https://ii-cms.s3.ap-southeast-1.amazonaws.com/ii-aedezel/a/slips/order_uid-' + this.db_order_uid + '.jpg';
						}

						if (this.current_nav == "logout") {
							localStorage.removeItem("coupon_code");
							localStorage.removeItem("payment");
							localStorage.removeItem("qty");
							localStorage.removeItem("adr_billing");
							localStorage.removeItem("adr_delivery");
							localStorage.removeItem("is_login");
							localStorage.removeItem("_cust");
							this.is_login = 0;
							location.href = "/";
							return;
						}

						if (this.current_nav == "dologin") {
							// alert("dologin");
							const res = await fetch("/api/dologin", {
								method: "POST",
								headers: { "Content-Type": "application/json" },
								body: JSON.stringify({
									customer: this.customer,
								}),
							});

							const res_json = await res.json();

							console.debug("dologin res:", res, res_json);

							if (res.status == 200) {
								// alert("ok")
								this.is_login = 1;
								this.customer = res_json.data.customer;

								this.adr_billing.provinceNameTh = this.customer.billing_province;
								this.adr_billing.districtNameTh = this.customer.billing_district;
								this.adr_billing.subdistrictNameTh = this.customer.billing_subdistrict;
								this.adr_billing.postalCode = this.customer.billing_zipcode;

								this.adr_delivery.provinceNameTh = this.customer.delivery_province;
								this.adr_delivery.districtNameTh = this.customer.delivery_district;
								this.adr_delivery.subdistrictNameTh = this.customer.delivery_subdistrict;
								this.adr_delivery.postalCode = this.customer.delivery_zipcode;

								location.href = "./account";
							} else {
								alert("login incorrect");
								location.href = "./login";
							}
						}

						if (
							this.current_nav == "confirm" ||
							this.current_nav == "signup" ||
							this.current_nav == "register" ||
							this.current_nav == "account" ||
							this.current_nav == "account-save"
						) {
							console.log("confirm|signup|register|account-save");

							if (this.current_nav == "signup" && this.is_login == 1) location.href = "/" + this.lang + "/account";
							if (this.current_nav == "account" && this.is_login == 0) location.href = "/" + this.lang + "/login";

							// Load geo.json into geo var
							try {
								const geoRes = await fetch("/ui/geography.json");
								if (geoRes.ok) {
									this.geo = await geoRes.json();
									console.debug("Loaded geo:", this.geo);

									if (this.current_nav == "register") {
										const res = await fetch("/api/register", {
											method: "POST",
											headers: { "Content-Type": "application/json" },
											body: JSON.stringify({
												customer: this.customer,
												// adr_billing: this.adr_billing,
												// adr_delivery: this.adr_delivery,
											}),
										});

										const res_json = await res.json();

										// clear cart
										// this.qty=0;
										// this.coupon_code = "";

										console.debug("checkout res:", res, res_json);

										if (res.status == 201) {
											alert("This email has already registered.");
											location.href = "/" + this.lang + "/signup";
											return;
										}

										this.is_login = 1;

										alert("Registered Successfully");
										if (this.qty > 0) location.href = "/" + this.lang + "/confirm";
										else location.href = "/" + this.lang + "/";
									}

									if (this.current_nav == "account-save") {
										const res = await fetch("/api/account-save", {
											method: "POST",
											headers: { "Content-Type": "application/json" },
											body: JSON.stringify({
												customer: this.customer,
												// adr_billing: this.adr_billing,
												// adr_delivery: this.adr_delivery,
											}),
										});

										const res_json = await res.json();

										// clear cart
										// this.qty=0;
										// this.coupon_code = "";

										console.debug("account-save res:", res, res_json);

										alert("Account Save Successfully");
										// location.href = "/" + this.lang + "/";
										/////
										location.href = "/" + this.lang + "/account";
									}
								} else {
									console.error("Failed to load geo.json");
								}
							} catch (e) {
								console.error("Error loading geo.json:", e);
							}

							// location.href="/{=$lang}/products";
						}

						// console.debug("qty:",this.qty);

						// GET URL
						let ref = new URLSearchParams(window.location.search).get("ref") || "";
						if (ref != "") this.customer.ref = ref;

						let c = new URLSearchParams(window.location.search).get("c") || "";
						if (c != "") this.coupon_code = c;
					},

					no_float() {
						this.show_topfloat = false;
						this.name_topfloat = "";
						this.show_bottomfloat = false;
						this.name_bottomfloat = "";
					},

					person(id) {
						this.show_person = true;
						this.person_id = id;
						console.debug("person: " + id);
					},
				};
			}

			function slipUploader() {
				return {
					file: null,
					previewUrl: "",
					dragging: false,
					uploading: false,
					progress: 0,
					statusMsg: "",
					maxSize: 3 * 1024 * 1024, // 5MB
					allowed: ["image/jpeg", "image/png"], // extend as needed

					reset() {
						this.file = null;
						this.previewUrl = "";
						this.dragging = false;
						this.uploading = false;
						this.progress = 0;
						this.statusMsg = "";
						if (this.$refs.file) this.$refs.file.value = "";
					},

					handleDrop(e) {
						this.dragging = false;
						const f = e.dataTransfer.files?.[0];
						if (f) this.acceptFile(f);
					},

					handleFile(e) {
						const f = e.target.files?.[0];
						if (f) this.acceptFile(f);
					},

					acceptFile(f) {
						if (!this.allowed.includes(f.type)) {
							this.statusMsg = "Unsupported file type.";
							return;
						}
						if (f.size > this.maxSize) {
							this.statusMsg = "File too large.";
							return;
						}
						this.file = f;
						this.statusMsg = `${f.name} (${Math.round(f.size / 1024)} KB)`;
						if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
						this.previewUrl = URL.createObjectURL(f);
					},
					async compressImage(file, { maxW = 1280, maxH = 1280, quality = 0.82, forceJpeg = false } = {}) {
						// 0) Block HEIC/HEIF (browser can’t draw it on canvas reliably)
						const lowerName = (file.name || "").toLowerCase();
						const isHeic = /(\.heic|\.heif)$/.test(lowerName) || /image\/hei[cf]/.test(file.type || "");
						if (isHeic) {
							console.warn("compressImage: HEIC/HEIF not supported in canvas; skipping compression.");
							throw new Error("heic-not-supported");
						}

						// 1) Decide output type
						const testCanvas = document.createElement("canvas");
						const webpOK = testCanvas.toDataURL("image/webp").startsWith("data:image/webp");
						const outType = forceJpeg ? "image/jpeg" : webpOK ? "image/webp" : "image/jpeg";
						const outExt = outType === "image/webp" ? "webp" : "jpg";

						// 2) Decode the image
						let sourceEl; // either ImageBitmap or HTMLImageElement
						try {
							if ("createImageBitmap" in window && typeof createImageBitmap === "function") {
								// Some browsers support options: { imageOrientation:'from-image' }
								sourceEl = await createImageBitmap(file);
							} else {
								sourceEl = await new Promise((resolve, reject) => {
									const url = URL.createObjectURL(file);
									const img = new Image();
									img.onload = () => {
										URL.revokeObjectURL(url);
										resolve(img);
									};
									img.onerror = () => {
										URL.revokeObjectURL(url);
										reject(new Error("decode-failed"));
									};
									img.src = url;
								});
							}
						} catch (e) {
							console.warn("compressImage: decode failed:", e);
							throw new Error("decode-failed");
						}

						const w = sourceEl.width || sourceEl.naturalWidth;
						const h = sourceEl.height || sourceEl.naturalHeight;
						if (!w || !h) {
							console.warn("compressImage: decoded image has zero dimensions.");
							throw new Error("zero-dimensions");
						}

						// 3) Compute target size (no upscaling)
						const scale = Math.min(maxW / w, maxH / h, 1);
						const newW = Math.max(1, Math.round(w * scale));
						const newH = Math.max(1, Math.round(h * scale));

						// 4) Draw to canvas
						let canvas, ctx;
						if (typeof OffscreenCanvas !== "undefined") {
							canvas = new OffscreenCanvas(newW, newH);
							ctx = canvas.getContext("2d", { alpha: false });
						} else {
							canvas = document.createElement("canvas");
							canvas.width = newW;
							canvas.height = newH;
							ctx = canvas.getContext("2d", { alpha: false });
						}
						ctx.imageSmoothingEnabled = true;
						ctx.imageSmoothingQuality = "high";
						ctx.drawImage(sourceEl, 0, 0, newW, newH);

						// 5) Get compressed blob
						const blob = await new Promise((resolve, reject) => {
							if (canvas.convertToBlob) {
								canvas
									.convertToBlob({ type: outType, quality })
									.then((b) => (b ? resolve(b) : reject(new Error("convertToBlob-null"))))
									.catch(reject);
							} else {
								// uses polyfilled toBlob if needed
								canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("toBlob-null"))), outType, quality);
							}
						});

						const base = (file.name || "slip").replace(/\.[^.]+$/, "") || "slip";
						const filename = `${base}.${outExt}`;
						return { blob, filename, mime: outType };
					},

					async upload() {
						if (!this.file) {
							this.statusMsg = "Please select a file first.";
							return;
						}
						this.slip_url = "";

						this.uploading = true;
						this.progress = 0;
						this.statusMsg = "Optimizing...";

						let toSend = this.file,
							sendName = this.file.name || "slip.jpg";

						try {
							// tweak maxW/maxH/quality as you like
							const { blob, filename } = await compressImage(this.file, { maxW: 1280, maxH: 1280, quality: 0.82 });
							toSend = blob;
							sendName = filename;
						} catch (e) {
							// fall back to original if compression fails (e.g., HEIC decode)
							console.warn("Compression skipped:", e.message || e);
						}

						this.statusMsg = "Uploading…";

						const form = new FormData();
						form.append("slip", toSend, sendName); // send the compressed blob
						form.append("order_uid", this.order_uid || "NOUID");

						const xhr = new XMLHttpRequest();
						xhr.open("POST", "/api/slip/upload", true);

						xhr.upload.onprogress = (e) => {
							if (e.lengthComputable) this.progress = Math.round((e.loaded / e.total) * 100);
						};

						xhr.onload = () => {
							this.uploading = false;

							try {
								const res = JSON.parse(xhr.responseText || "{}");
								if (xhr.status >= 200 && xhr.status < 300 && (res.status === "success" || res.success)) {
									this.statusMsg = "Uploaded successfully.";
									console.debug("Upload response:", res);
									console.debug("Upload key:", res.key);
									this.slip = true;

									// this.slip_url = 'https://ii-cms.s3.ap-southeast-1.amazonaws.com/ii-aedezel/a/slips/order_uid-' + this.db_order_uid + '.jpg';

									this.slip_url = res.slip_url;

									this.reset();
									console.debug("RESET");
								} else {
									this.statusMsg = res.message || "Upload failed.";
								}
							} catch {
								this.statusMsg = "Upload failed (invalid server response).";
							}
						};

						xhr.onerror = () => {
							this.uploading = false;
							this.statusMsg = "Network error during upload.";
						};

						xhr.send(form);
					},
				};
			}

			Alpine.data("mainApp", mainApp);

			Alpine.data("slipUploader", slipUploader);
			Alpine.start();
			console.debug("inited");
		